import { Card, Typography, Divider, Tabs } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import PersonalDetails from "./AddNewQCTabs/PersonalDetails";
import { jwtDecode } from "jwt-decode";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../utils/global/localData";
import { checkPermissionAction } from "../../../utils/helper/utils";
import { useEffect } from "react";

const AddNewQC = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(
      storageKeys?.USER_TOKEN,
      {},
      "get"
    );
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Manage QC", permissionJson, "edit")) {
        navigate("/manage-qc");
      }
    } else {
      if (!checkPermissionAction("Manage QC", permissionJson, "add")) {
        navigate("/manage-qc");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Card>
        <div className="">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
            {id ? "Edit" : "Add"} QC
          </Typography>
        </div>
        <Divider />
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab={"Personal details"} key={1}>
            <PersonalDetails />
          </Tabs.TabPane>
          {/* <Tabs.TabPane tab={"Working hours"} key={2}>
            <WorkingHours />
          </Tabs.TabPane>
          <Tabs.TabPane tab={"Holidays"} key={3}>
            <Holidays />
          </Tabs.TabPane> */}
        </Tabs>
        <Divider />
      </Card>
    </>
  );
};
export default AddNewQC;
